// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card-body[data-v-65e8991e]{flex-direction:column;min-height:12rem}.field[data-v-65e8991e]{flex-shrink:0}@media print,screen and (min-width:769px){[data-int=order-cell-address-modal][data-v-65e8991e]{top:-2em}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
